import { RouteRecordRaw } from "vue-router";
import { PAGE_TYPE } from "@supplier/meta";
import Layout from "@/views/layouts/index.vue";

export const logisticsRouter: RouteRecordRaw[] = [
    {
        path: "/logistics",
        name: "LogisticsManagement",
        component: Layout,
        redirect: "/logistics/ShipOrder",
        meta: {
            title: "物流管理"
        },
        children: [
            {
                path: "shipOrder",
                name: "ShipOrder",
                component: () => import("@/views/pages/logisticsManagement/shipOrder/index.vue"),
                meta: {
                    title: "船运单管理",
                    keepAlive: true,
                    pageType: PAGE_TYPE.LIST.code
                }
            },
            {
                path: "shipOrder/add",
                name: "ShipOrderAdd",
                component: () => import("@/views/pages/logisticsManagement/shipOrder/form.vue"),
                meta: {
                    title: "船运单管理",
                    activeMenu: "ShipOrder",
                    keepAlive: true,
                    hidden: true
                }
            },
            {
                path: "shipOrder/edit",
                name: "ShipOrderEdit",
                component: () => import("@/views/pages/logisticsManagement/shipOrder/offlineForm.vue"),
                meta: {
                    title: "修改船运单",
                    activeMenu: "ShipOrder",
                    keepAlive: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    hidden: true
                }
            },
            {
                path: "shipOrder/detail",
                name: "ShipOrderDetail",
                component: () => import("@/views/pages/logisticsManagement/shipOrder/detail.vue"),
                meta: {
                    title: "船运单详情",
                    activeMenu: "ShipOrder",
                    hidden: true
                }
            },
            {
                path: "transport",
                name: "TransportBill",
                component: () => import("@/views/pages/logisticsManagement/transportBill/index.vue"),
                meta: {
                    title: "汽运单管理",
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.LIST.code
                }
            },
            {
                path: "transport/detail",
                name: "TransportBillDetail",
                component: () => import("@/views/pages/logisticsManagement/transportBill/detail.vue"),
                meta: {
                    title: "汽运单详情",
                    hidden: true,
                    isNotShowHeader: true,
                    activeMenu: "TransportBill",
                    pageType: PAGE_TYPE.DETAIL.code
                }
            },
            {
                path: "transport/add",
                name: "TransportBillAdd",
                component: () => import("@/views/pages/logisticsManagement/transportBill/form.vue"),
                meta: {
                    title: "新增汽运单",
                    hidden: true,
                    activeMenu: "TransportBill",
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code
                }
            },
            {
                path: "transport/edit",
                name: "TransportBillEdit",
                component: () => import("@/views/pages/logisticsManagement/transportBill/form.vue"),
                meta: {
                    title: "修改汽运单",
                    hidden: true,
                    activeMenu: "TransportBill",
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code
                }
            },
            {
                path: "railwayOrder",
                name: "RailwayOrder",
                component: () => import("@/views/pages/logisticsManagement/railwayOrder/index.vue"),
                meta: {
                    title: "铁路单管理",
                    pageType: PAGE_TYPE.LIST.code
                }
            },
            {
                path: "railwayOrder/detail",
                name: "RailwayOrderDetail",
                component: () => import("@/views/pages/logisticsManagement/railwayOrder/detail.vue"),
                meta: {
                    title: "铁路单详情",
                    hidden: true,
                    activeMenu: "RailwayOrder",
                    isNotShowHeader: true
                }
            },
            {
                path: "railwayOrder/add",
                name: "RailwayOrderAdd",
                component: () => import("@/views/pages/logisticsManagement/railwayOrder/form.vue"),
                meta: {
                    title: "新增铁路单",
                    hidden: true,
                    activeMenu: "RailwayOrder",
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code
                }
            },
            {
                path: "railwayOrder/edit",
                name: "RailwayOrderEdit",
                component: () => import("@/views/pages/logisticsManagement/railwayOrder/form.vue"),
                meta: {
                    title: "修改铁路单",
                    hidden: true,
                    activeMenu: "RailwayOrder",
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    isNotShowHeader: true
                }
            }
        ]
    }
];

export default logisticsRouter;
